import Question from './Question';

export const ComplianceSurveyQuestion = () => {
  return (
    <Question
      title='Screening Question' />
  );
};

export default ComplianceSurveyQuestion;